/**
 * Club id from a club-admin (or similar) invitation JWT in the page URL.
 * Used so brand/logo can resolve before the invite API returns.
 */
export function decodeJwtPayload(token) {
  try {
    const part = String(token || "").split(".")[1];
    if (!part) return null;
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64.padEnd(Math.ceil(b64.length / 4) * 4, "=");
    const json = decodeURIComponent(
      Array.from(atob(padded), (c) => `%${c.charCodeAt(0).toString(16).padStart(2, "0")}`).join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getClubIdFromInvitationSearch(search = "") {
  try {
    const params = new URLSearchParams(
      String(search || (typeof window !== "undefined" ? window.location.search : "")).replace(
        /^\?/,
        ""
      )
    );
    const token = params.get("invitation_token");
    const payload = decodeJwtPayload(token);
    const clubId = payload?.club_id;
    return clubId ? String(clubId).trim() : null;
  } catch {
    return null;
  }
}
